import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "container col-xxl-8 px-4 py-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" style=\"float:left;margin-top:2em;margin-right:2em;height:5em;width:auto;\" class=\"img-circle\"><h2>Ape Tools - Image Gorilla</h2><p class=\"lead\"> Tired of creating all your icons and splashscreen sizes manually? You&#39;ve come to the right place. </p><p> Upload your Icons and/or Splashscreen and we&#39;ll do all the hard work to create the sizes you need for each platform: </p><p> Need to design a logo first? Try <a target=\"_blank\" href=\"https://logojoy.grsm.io/apetools\">Logojoy</a></p><p> Want to quickly make some PNGs (or JPGs) tiny? Check out <a target=\"_blank\" href=\"https://www.betweenelements.com/tinypng-app\">tinyPNG.App</a></p><p> Is it just too hard to manage your website certificates? See <a target=\"_blank\" href=\"https://certifytheweb.com\">Certify the web</a></p>", 7)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "panel panel-default" }
const _hoisted_14 = { class: "panel-body" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Step 1 - Select Your Icon", -1)
const _hoisted_16 = { class: "input-group file-upload" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " Select an Icon image in PNG format (transparency allowed) measuring 1024x1024 pixels. ", -1)
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "panel panel-default" }
const _hoisted_20 = { class: "panel-body" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Step 2 - Select Your Splashscreen", -1)
const _hoisted_22 = { class: "input-group file-upload" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Select a Splashscreen image in PNG format (no transparency) measuring 4096*4096 pixels with the important stuff centred, we'll then resize from the centre outwards, sampling the top left corner colour as background. ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" })
], -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", {
  class: "clearfix",
  style: {"clear":"left"}
}, " Step 3 - Where the magic happens ", -1)
const _hoisted_27 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Ready to Punch It? ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Kapow! ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["id"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, " show previews", -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin fa-3x fa-fw",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_36 = { class: "progress" }
const _hoisted_37 = { class: "sr-only" }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://apetools.webprofusion.com",
  class: "ms-2"
}, "Try Again", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " We will generate an asset bundle you can download for the following platforms: ", -1)
const _hoisted_41 = { class: "lead" }
const _hoisted_42 = ["id", "onUpdate:modelValue"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, " include in bundle ", -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "list-group-item" }
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "well well-sm" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" We'd really appreciate it if you could tell others about this app: "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://twitter.com/share",
      class: "twitter-share-button",
      "data-url": "https://apetools.webprofusion.com",
      "data-text": "Check out Ape Tools, the quick way to generate all the icons and splash screens for your app:",
      "data-via": "webprofusion"
    }, "Share")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    id: "fileupload-icon",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectionChanged('icon', $event))),
                    name: "FileUploadIcon"
                  }, null, 32)
                ]),
                _hoisted_17
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    id: "fileupload-splash",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectionChanged('splash', $event))),
                    name: "FileUploadSplash"
                  }, null, 32)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_23,
                  _createElementVNode("span", {
                    class: "sample-swatch",
                    style: _normalizeStyle(_ctx.sampleStyle)
                  }, " ", 4)
                ])
              ])
            ])
          ])
        ]),
        _hoisted_24,
        (_ctx.selectedIconFile || _ctx.selectedSplashFile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              (!_ctx.isProcessing && !_ctx.isArchiveReady)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.process && _ctx.process(...args))),
                      class: "btn btn-primary btn-lg"
                    }, _hoisted_31),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: _ctx.showPreviews,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showPreviews) = $event))
                    }, null, 8, _hoisted_32), [
                      [_vModelCheckbox, _ctx.showPreviews]
                    ]),
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isProcessing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _hoisted_35,
                    _createTextVNode(" " + _toDisplayString(_ctx.msg) + " ", 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: "progress-bar",
                        role: "progressbar",
                        "aria-valuenow": "70",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: _normalizeStyle({ width: _ctx.processingProgress + '%' })
                      }, [
                        _createElementVNode("span", _hoisted_37, "Processing " + _toDisplayString(_ctx.processingProgress) + "% Complete", 1)
                      ], 4)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isArchiveReady)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("button", {
                      class: "btn btn-success btn-lg",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadZip && _ctx.downloadZip(...args)))
                    }, " Download Zip "),
                    _hoisted_39
                  ]))
                : _createCommentVNode("", true),
              _hoisted_40,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPlatforms, (platform) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: platform.id,
                  style: {"width":"300px","min-height":"100px","display":"inline-block","border":"1px solid gainsboro","box-shadow":"#c0c0c0 2px 2px","padding":"1em","margin":"1em"}
                }, [
                  _createElementVNode("h3", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa fa-lg fa-fw", platform.icon])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(platform.title), 1)
                  ]),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(platform.bundleSpecs.filter((f) => f.category == "icon")[0]
                  .imageSet.length) + " icon sizes, " + _toDisplayString(platform.bundleSpecs.filter((f) => f.category == "splash")[0]
                  .imageSet.length) + " splashscreen sizes. ", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: platform.path,
                    "onUpdate:modelValue": ($event: any) => ((platform.includeInBundle) = $event)
                  }, null, 8, _hoisted_42), [
                    [_vModelCheckbox, platform.includeInBundle]
                  ]),
                  _hoisted_43,
                  (platform.includeInBundle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("p", null, _toDisplayString(platform.instructions), 1),
                        (_ctx.showPreviews)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platform.bundleSpecs, (bundle) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: bundle.category
                                }, [
                                  _createElementVNode("h2", null, _toDisplayString(bundle.category), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((bundle.prefix) = $event),
                                    placeholder: "file name prefix"
                                  }, null, 8, _hoisted_46), [
                                    [_vModelText, bundle.prefix]
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bundle.imageSet, (fileSpec, i) => {
                                    return (_openBlock(), _createElementBlock("ul", {
                                      class: "list-group",
                                      key: i
                                    }, [
                                      _createElementVNode("li", _hoisted_47, [
                                        _createTextVNode(_toDisplayString(fileSpec.path) + " " + _toDisplayString(fileSpec.prefix) + " " + _toDisplayString(fileSpec.idiom) + " " + _toDisplayString(fileSpec.fileName) + ": " + _toDisplayString(fileSpec.width * fileSpec.scale) + "x" + _toDisplayString(fileSpec.height * fileSpec.scale) + " ", 1),
                                        (fileSpec.imgData)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: fileSpec.imgData,
                                              style: {"max-width":"200px","max-height":"200px"},
                                              class: "img-thumbnail"
                                            }, null, 8, _hoisted_48))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_49
    ])
  ]))
}